import { IBaseModel } from "../BaseModel";

export enum FeatureStatus {
  Archived,
  Disabled,
  Enabled,
  Preview,
}

export interface IFeature extends IBaseModel {
  name: string;
  status: FeatureStatus;
}
